var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[(_vm.isBack)?_c('div',{staticClass:"header__back",on:{"click":function($event){return _vm.$emit('back')}}}):_vm._e(),_c('div',{staticClass:"header__fill",style:(("width: " + _vm.width + "%"))})])}
var staticRenderFns = []

export { render, staticRenderFns }